import moment from 'moment-timezone';
import { base } from './api';

export * from './api';

// prettier-ignore
export const blobPropType = (props, propName, componentName) =>
  props[propName] instanceof Blob
    ? null
    : new Error(
      `Invalid prop ${propName} supplied to component ${componentName}`
    );

export const formatDate = (date, small = false) =>
  small
    ? moment(date).tz('America/Chicago').format('MM/DD/YYYY')
    : moment(date).tz('America/Chicago').format('dddd, MMMM Do YYYY');

export const assetFileNameToUrl = fileName => `${base}${fileName}`;

export const depluralize = string => string.replace(/s$/, '');

export const isValidPhoneNumber = value =>
  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);

/**
 * Tests if a string is in the proper format for a U.S. ZIP code
 * @param {string} value - the value to test
 * @return {boolean} if the value matches formatting for a U.S. ZIP code
 */
export const isValidZipCode = value => /^\d{5}(?:[- ]?\d{4})?$/.test(value);
